import axios from 'axios';

const uri = process.env.VUE_APP_BACKEND_URL + process.env.VUE_APP_API_URI;
export default {
    /**
     * Méthode d'appel de l'API pour effectuer une recherche de formation.
     * @param {String} q La formation saisie par l'utilisateur
     * @returns {Promise}
     */
    search(q) {
        return axios.get(`${uri}/search?q=${q}&limit=5`)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    /**
     * Méthode d'appel de l'API pour envoyer le mail de récapitulatif.
     * @param {String} email adresse mail de destination
     * @param  {Object} informationsRecapitulatif Les informations récapitulatives à inclure dans le mail
     * @param  {Function} callback La méthode à appeler une fois la requête effectuée.
     * @returns {Promise}
     */
    sendMail(email, informationsRecapitulatif, callback) {
        return axios.post(`${uri}/mail/envoyer`, informationsRecapitulatif).then(callback).catch(callback);
    }
};
